import getObject from './get-object.js';
import keys from './keys.js';

export default function getTouchpoints() {
    let touchpoints = getObject(keys.sgTouchPoints);
    touchpoints = touchpoints ? touchpoints.slice(0, 10) : [];
    return touchpoints.map(touchpoint => {
        let object = {};
        object[touchpoint.origin] = touchpoint.origin_id;
        return object;
    });
}